export default "__VITE_ASSET__DENkISgT__"